import React from "react";
import LegalDocumentView from "../../components/legal/LegalDocumentView";
import { useLegalDocument } from "../../hooks/useLegalDocument";

const TermsAndConditions: React.FC = () => {
  const legalDocument = useLegalDocument("termsAndConditions");

  return <LegalDocumentView legalDocument={legalDocument} />;
};

export default TermsAndConditions;
